import axios, { AxiosResponse } from 'axios';
import { ILeiDetailData } from 'types/leiTypes';

import { IZalozeniLeiResp } from './zalozeniLei';

const leiAktualizace = (
    method: 'put' | 'post' | 'get',
    varsym: string,
    idZadosti?: number | string,
    data?: ILeiDetailData
) => {
    return axios({
        method: method,
        url: `LEI/${varsym}/aktualizace/${idZadosti}`,
        data: data
    }).then((resp: AxiosResponse<ILeiDetailData>) => resp.data);
};

export const leiAktualizaceInit = (varsym: string) => {
    return axios({
        method: 'post',
        url: `LEI/${varsym}/aktualizace`
    }).then((resp: AxiosResponse<IZalozeniLeiResp>) => resp.data);
};

export default leiAktualizace;
